import { isBrowser } from './utils'

/**
 * Implementations must be synchronous.
 */
export interface StorageAdapter {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

export class LocalStorageAdapter implements StorageAdapter {
  getItem(key: string): string | null {
    if (!isBrowser()) {
      return null
    }
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  }

  setItem(key: string, value: string): void {
    if (!isBrowser()) {
      return
    }
    try {
      localStorage.setItem(key, value)
    } catch {
      // silent fallback (e.g. quota exceeded)
    }
  }

  removeItem(key: string): void {
    if (!isBrowser()) {
      return
    }
    try {
      localStorage.removeItem(key)
    } catch {
      // silent fallback
    }
  }
}

export class InMemoryStorageAdapter implements StorageAdapter {
  private readonly store = new Map<string, string>()

  getItem(key: string): string | null {
    return this.store.get(key) ?? null
  }

  setItem(key: string, value: string): void {
    this.store.set(key, value)
  }

  removeItem(key: string): void {
    this.store.delete(key)
  }
}

export function createDefaultStorage(): StorageAdapter {
  return isBrowser() ? new LocalStorageAdapter() : new InMemoryStorageAdapter()
}
